import {Routes, Route} from "react-router-dom";

import PrivateRoute from "./shared/components/PrivateRoute";
import PublicRoute from "./shared/components/PublicRoute";

import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import RegistrationsPage from "./pages/RegistrationsPage";
import ClientsPage from "./pages/ClientsPage";
import DelegatesPage from "./pages/DelegatesPage";
import EarningPage from "./pages/EarningPage";
import MissionsPage from "./pages/MissionsPage";
import InsightsPage from "./pages/InsightsPage";
import MissionsByPersonPage from "./pages/MissionsByPersonPage/MissionsByPersonPage";
import SupportPage from "./pages/SupportPage";
import SingleMissionPage from "./pages/SingleMissionPage";
import AdministratorsPage from "./pages/AdministratorsPage";
import AdminInvitationPage from "./pages/AdminInvitationPage";
import PartnersPage from "./pages/PartnersPage";
import SuperAdminRoute from "./shared/components/SuperAdminRoute";

const UserRoutes = () => {
    return (
        <Routes>
            <Route path="/admin-invitation" element={<AdminInvitationPage/>}/>
            <Route element={<PublicRoute />}>
                <Route path="/" element={<LoginPage />}/>
            </Route>
            <Route element={<PrivateRoute />}>
                <Route path="/dashboard" element={<DashboardPage/>}/>
                <Route path="/registrations" element={<RegistrationsPage/>}/>
                <Route path="/clients" element={<ClientsPage/>} />
                <Route path="/clients/:id/missions" element={<MissionsByPersonPage />}/>
                <Route path="/delegates" element={<DelegatesPage/>}/>
                <Route path="/payment" element={<EarningPage/>}/>
                <Route path="/missions" element={<MissionsPage/>}/>
                <Route path="/missions/:id" element={<SingleMissionPage/>}/>
                <Route path="/insights" element={<InsightsPage/>}/>
                <Route path="/support" element={<SupportPage/>}/>
                <Route path="/partners" element={<PartnersPage/>}/>
                <Route element={<SuperAdminRoute/>}>
                    <Route path="/administrators" element={<AdministratorsPage/>}/>
                </Route>
            </Route>
        </Routes>
    )
}

export default UserRoutes;
